import { createStore } from 'vuex'
import api from '@/api'
import profile from '@/utils/profile'
import { jsFn } from '@/utils/jsFn'
import coreApi from './module/coreApi'
import activity from './module/activity'
import ies5Api from './module/ies5Api'
import sokplatformApi from './module/sokplatformApi'

const cheerio = require("cheerio")
const KEEPSTORAGE = 'KEEPSTORAGE'
const SETNEWSDATA = 'SETNEWSDATA'
const SETACADMICDATA = 'SETACADMICDATA'
const SETEVENTDATA = 'SETEVENTDATA'
const SETOSDATABYID = 'SETOSDATABYID'
const overDay = 1 // 超過幾天要更新

export default createStore({
  state: {
    // 官網 Menu
    os: {
      news: {
        tw: {
          time: '',
          data:[]
        },
        cn: {
          time: '',
          data:[]
        },
        en: {
          time: '',
          data:[]
        }
      },
      academic: {
        tw: {
          time: '',
          data:[]
        },
        cn: {
          time: '',
          data:[]
        },
        en: {
          time: '',
          data:[]
        }
      },
      event: {
        tw: {
          time: '',
          data:[]
        },
        cn: {
          time: '',
          data:[]
        },
        en: {
          time: '',
          data:[]
        }
      }
    },
    version: 'v1.2.20260128'
  },
  getters: {
    discoverystw: function(state) {
      let data = state.os.news.tw.data.concat(state.os.academic.tw.data, state.os.event.tw.data)
      // let data = state.os.news.tw.data.concat(state.os.academic.tw.data)
      data.sort(function(a, b) {
        return new Date(b.crtTime) - new Date(a.crtTime)
      })
      return data
    },
    discoveryscn: function(state) {
      let data = state.os.news.cn.data.concat(state.os.academic.cn.data, state.os.event.cn.data)
      // let data = state.os.news.cn.data.concat(state.os.academic.cn.data)
      data.sort(function(a, b) {
        return new Date(b.crtTime) - new Date(a.crtTime)
      })
      return data
      
    },
    discoverysen: function(state) {
      let data = state.os.news.en.data.concat(state.os.academic.en.data, state.os.event.en.data)
      // let data = state.os.news.en.data.concat(state.os.academic.en.data)
      data.sort(function(a, b) {
        return new Date(b.crtTime) - new Date(a.crtTime)
      })
      return data
    }
  },
  mutations: {
    [KEEPSTORAGE](state, data) {
      let dataKeys = Object.keys(data)
      dataKeys.forEach(key => {
        state[key] = data[key]
      })
    },
    [SETNEWSDATA](state, data) {
      state.os.news[data.lang] = data.detail
    },
    [SETOSDATABYID](state, data) {
      state.os[data.type][data.lang].data.forEach( item =>{
        if(parseInt(item.id) === data.id) {
          item.html = data.html
        }
      })
    },
    [SETACADMICDATA](state, data) {
      state.os.academic[data.lang] = data.detail
    },
    [SETEVENTDATA](state, data) {
      state.os.event[data.lang] = data.detail
    }    
  },
  actions: {
    /** 
     * NOTE: 取得官網教育快訊List
     * @param {String} lang - 語系
     * @return {String}
    */
    getOSNewsHTML(context, lang) {
      // 日、韓先抓英文版
      if(lang == 'jp' || lang == 'kr') {
        lang = 'en'
      }
      return new Promise((resolve, reject) => {
        // 檢查是否已隔天或空值
        function isRest(){
          let res = false
          let now = new Date().getTime()
          let time = context.state.os.news[lang].time
          let ans = (now - time) / (24 * 60 * 60 * 1000)
          if(ans >= overDay) res = true
          return res
        }
        if(jsFn.IsEmpty(context.state.os.news[lang].time) || isRest()) {
          // 拿取新資料
          let url = profile.reptileURL.OS.url[lang]
          let page = profile.reptileURL.OS.page.news[lang]
          api.GetWebHTML(url + page).then(res => {
            const $ = cheerio.load(res); // 載入 body
            let result = []; // 建立一個儲存結果的容器
            $('.box.showrole.scroll-fade-up a').each(function(i, v){
              let type = 'news'
              let id = i + 1
              let title = $(v).children('.txt').children('.ti').text()
              let htmlUrl = $(v).attr().href
              let html = ''
              let subTitle = $(v).children('.txt').children('p').text()
              let logo = url + $(v).children('.pic').children('img').attr('data-src')
              let crtTime = $(v).children('.txt').children('.date').text()
              result.push(Object.assign({ id, title, htmlUrl, subTitle, logo, crtTime, html, type }));
            })
            let data = {
              lang: lang,
              detail: {
                time: new Date().getTime(), 
                data: result
              }
            }
            context.commit(SETNEWSDATA, data)
            context.dispatch('saveState') // 存到localstorage
            resolve(true)
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve('不用拿取新資料')
        }
      })
    },
    /** 
     * NOTE: 取得官網學術發表List
     * @param {String} lang - 語系
     * @return {String}
    */
    getOSAcademicHTML(context, lang) {
      // 日、韓先抓英文版
      if(lang == 'jp' || lang == 'kr') {
        lang = 'en'
      }
      return new Promise((resolve, reject) => {
        // 檢查是否已隔天或空值
        function isRest(){
          let res = false
          let time1 = new Date().getDate()
          let time2 = new Date(context.state.os.academic[lang].time).getDate()
          if(Math.abs(time1 - time2) >= overDay) res = true
          return res
        }
        if(jsFn.IsEmpty(context.state.os.academic[lang].time) || isRest()) {
          // 拿取新資料
          let url = profile.reptileURL.OS.url[lang]
          let page = profile.reptileURL.OS.page.academic[lang]
          api.GetWebHTML(url + page).then(res => {
            const $ = cheerio.load(res); // 載入 body
            let result = []; // 建立一個儲存結果的容器
            $('.items.showrole.scroll-fade-up a').each(function(i, v){
              let type = 'academic'
              let id = i + 1
              let title = $(v).children('.name').text()
              let htmlUrl = $(v).attr().href
              let html = ''
              let subTitle = ''
              let logo = url + $(v).children('.pic').children('img').attr('data-src')
              let crtTime = $(v).children('.date').text()
              result.push(Object.assign({ id, title, htmlUrl, subTitle, logo, crtTime, html, type }));
            })
            let data = {
              lang: lang,
              detail: {
                time: new Date().getTime(), 
                data: result
              }
            }
            context.commit(SETACADMICDATA, data)
            context.dispatch('saveState') // 存到localstorage
            resolve(true)
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve('不用拿取新資料')
        }
      })
    },
    /** 
     * NOTE: 取得活動專區List
     * @param {String} lang - 語系
     * @return {String}
    */
    getOSEventHTML(context, lang) {
      // 日、韓先抓英文版
      if(lang == 'jp' || lang == 'kr') {
        lang = 'en'
      }
      return new Promise((resolve, reject) => {
        // 檢查是否已隔天或空值
        function isRest(){
          let res = false
          if(context.state.os.event){
            let time1 = new Date().getDate()
            let time2 = new Date(context.state.os.event[lang].time).getDate()
            if(Math.abs(time1 - time2) >= overDay) res = true
          }
          return res
        }
        if(jsFn.IsEmpty(context.state.os.event[lang].time) || isRest()) {
          // 拿取新資料
          let url = profile.reptileURL.OS.url[lang]
          let page = profile.reptileURL.OS.page.event[lang]
          api.GetWebHTML(url + page).then(res => {
            const $ = cheerio.load(res); // 載入 body
            let result = []; // 建立一個儲存結果的容器
            $('.box.showrole.scroll-fade-up a').each(function(i, v){
              let type = 'event'
              let id = i + 1
              let title = $(v).children('.txt').children('.ti').text()
              let htmlUrl = $(v).attr().href
              let html = ''
              let subTitle = $(v).children('.txt').children('p').text()
              let logo = url + $(v).children('.pic').children('img').attr('data-src')
              let crtTime = $(v).children('.txt').children('.date').text()
              result.push(Object.assign({ id, title, htmlUrl, subTitle, logo, crtTime, html, type }));
            })
            let data = {
              lang: lang,
              detail: {
                time: new Date().getTime(), 
                data: result
              }
            }
            context.commit(SETEVENTDATA, data)
            context.dispatch('saveState') // 存到localstorage
            resolve(true)
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve('不用拿取新資料')
        }
      })
    },
    /** 
     * NOTE: 取得官網指定內容
     * @param {Object} data -  {lang: lang, id: id}
    */
    getOSHTMLByID(context, data) {
      return new Promise((resolve, reject) => {
        let article = context.state.os[data.type][data.lang].data.filter((item)=>{
            return item.id == data.id
        })[0]
        if(jsFn.IsEmpty(article.html)){
          let url = profile.reptileURL.OS.url[data.lang]
          api.GetWebHTML(url + article.htmlUrl).then(res => {
            const $ = cheerio.load(res); // 載入 body
            let temp = {
              type: data.type,
              id: parseInt(data.id),
              lang: data.lang,
              html: $('.text-edit').html()
            }
            context.commit(SETOSDATABYID, temp)
            context.dispatch('saveState') // 存到localstorage
            resolve(true)
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve('不用拿取新資料')
        }        
      })
    },
    /** 
     * NOTE: 取得HiTA5 更新資訊
    */
    GetAPPVerInfo() {
      return new Promise((resolve, reject) => {
        api.GetAPPVerInfo().then((res) => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    /** 
     * NOTE: 維持 vuex state 的資訊
     * 備註: 如果這邊State 有新增值這邊也要新增
    */
    keepState(context) {
      if(!jsFn.IsEmpty(localStorage.getItem('stateData'))) {
        let stateData = JSON.parse(decodeURIComponent(localStorage.getItem('stateData'),'utf-8'))
        context.commit(KEEPSTORAGE, { // os另外處理
          os: stateData.os
        })
      }
    },
    /** 
    * NOTE: 儲存現在 state 的資訊
    * 備註: 如果這邊State 有新增值這邊也要新增
    */
    saveState(context) {
      let data = { // os另外處理
        os: context.state.os
      }
      localStorage.setItem('stateData', encodeURIComponent(JSON.stringify(data), 'utf-8'))
    }
  },
  modules: {
    coreApi,
    activity,
    ies5Api,
    sokplatformApi
  }
});
